// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Zndh9","jobCards":"styles_jobCards__tMdjP","viewJobsButton":"styles_viewJobsButton__M996w","noJobsMessage":"styles_noJobsMessage__tDKCw"};